import classNames from 'classnames';
import React, {PropsWithChildren} from 'react';

type Props = {
  variant?: 'primary' | 'secondary';
  className?: string;
};

const Tag = ({children, variant = 'primary', className}: PropsWithChildren<Props>) => {
  return (
    <div
      className={classNames(
        'px-xs py-1 text-2xs border border-primary-300 bg-primary-300 text-primary-700 rounded-full whitespace-nowrap',
        variant === 'primary' && 'font-regular bg-opacity-5',
        variant === 'secondary' && 'font-semibold',
        className
      )}
    >
      {children}
    </div>
  );
};

export default Tag;
